export default "__VITE_ASSET__BZl2yYDX__"